'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sized = exports.Ranged = exports.Maybe = exports.DynamicInlineSchema = exports.DynamicNeighbourSchema = exports.DynamicContainerField = exports.PendingSchema = exports.PendingContainerField = exports.Schema = exports.Map = exports.List = exports.ContainerField = exports.AnyImmutable = exports.Any = exports.Date = exports.String = exports.Boolean = exports.Integer = exports.Number = exports.StringAboveMaxLength = exports.StringBelowMinLength = exports.StringInvalid = exports.SchemaInvalid = exports.SizeInvalidBelowMin = exports.SizeInvalidAboveMax = exports.SizeInvalid = exports.SizeUnknown = exports.RangeInvalidBelowMin = exports.RangeInvalidAboveMax = exports.RangeInvalid = exports.NumberAboveMax = exports.NumberBelowMin = exports.NumberInvalid = exports.MapInvalid = exports.ListInvalid = exports.ReferencePending = exports.KeysUnknown = exports.IntegerAboveMax = exports.IntegerBelowMin = exports.IntegerInvalid = exports.DateInvalid = exports.BooleanInvalid = exports.ValidationError = exports.Specifier = exports.Modifier = exports.Field = exports.FieldPrimitive = exports.MAP_VALUE = exports.MAP_KEY = exports.ValidationResult = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _exceptions = require('./exceptions');

var _utils = require('./utils');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MAP_KEY = Symbol('key');
var MAP_VALUE = Symbol('value');

/*********************************************************************************************************************
 * ERRORS
 *********************************************************************************************************************/

var SchemaValidationError = function () {
  function SchemaValidationError(field, value) {
    _classCallCheck(this, SchemaValidationError);

    this.field = field;
    this.value = value;
  }

  _createClass(SchemaValidationError, [{
    key: 'toString',
    value: function toString() {
      return "Schema validation error base.";
    }
  }, {
    key: 'values',
    get: function get() {
      return { value: this.value };
    }
  }]);

  return SchemaValidationError;
}();

var SchemaFieldInvalid = function (_SchemaValidationErro) {
  _inherits(SchemaFieldInvalid, _SchemaValidationErro);

  function SchemaFieldInvalid() {
    _classCallCheck(this, SchemaFieldInvalid);

    return _possibleConstructorReturn(this, (SchemaFieldInvalid.__proto__ || Object.getPrototypeOf(SchemaFieldInvalid)).apply(this, arguments));
  }

  _createClass(SchemaFieldInvalid, [{
    key: 'getMessage',
    value: function getMessage() {
      return 'should be a ' + this.fieldType;
    }
  }, {
    key: 'toString',
    value: function toString() {
      return this.value + ' ' + this.getMessage();
    }
  }, {
    key: 'fieldType',
    get: function get() {
      throw new Error("Field type");
    }
  }]);

  return SchemaFieldInvalid;
}(SchemaValidationError);

var SchemaNumberInvalid = function (_SchemaFieldInvalid) {
  _inherits(SchemaNumberInvalid, _SchemaFieldInvalid);

  function SchemaNumberInvalid() {
    _classCallCheck(this, SchemaNumberInvalid);

    return _possibleConstructorReturn(this, (SchemaNumberInvalid.__proto__ || Object.getPrototypeOf(SchemaNumberInvalid)).apply(this, arguments));
  }

  _createClass(SchemaNumberInvalid, [{
    key: 'fieldType',
    get: function get() {
      return 'number';
    }
  }]);

  return SchemaNumberInvalid;
}(SchemaFieldInvalid);

var SchemaIntegerInvalid = function (_SchemaFieldInvalid2) {
  _inherits(SchemaIntegerInvalid, _SchemaFieldInvalid2);

  function SchemaIntegerInvalid() {
    _classCallCheck(this, SchemaIntegerInvalid);

    return _possibleConstructorReturn(this, (SchemaIntegerInvalid.__proto__ || Object.getPrototypeOf(SchemaIntegerInvalid)).apply(this, arguments));
  }

  _createClass(SchemaIntegerInvalid, [{
    key: 'getMessage',
    value: function getMessage() {
      return 'should be an ' + this.fieldType;
    }
  }, {
    key: 'fieldType',
    get: function get() {
      return 'integer';
    }
  }]);

  return SchemaIntegerInvalid;
}(SchemaFieldInvalid);

var SchemaBooleanInvalid = function (_SchemaFieldInvalid3) {
  _inherits(SchemaBooleanInvalid, _SchemaFieldInvalid3);

  function SchemaBooleanInvalid() {
    _classCallCheck(this, SchemaBooleanInvalid);

    return _possibleConstructorReturn(this, (SchemaBooleanInvalid.__proto__ || Object.getPrototypeOf(SchemaBooleanInvalid)).apply(this, arguments));
  }

  _createClass(SchemaBooleanInvalid, [{
    key: 'fieldType',
    get: function get() {
      return 'boolean';
    }
  }]);

  return SchemaBooleanInvalid;
}(SchemaFieldInvalid);

var SchemaStringInvalid = function (_SchemaFieldInvalid4) {
  _inherits(SchemaStringInvalid, _SchemaFieldInvalid4);

  function SchemaStringInvalid() {
    _classCallCheck(this, SchemaStringInvalid);

    return _possibleConstructorReturn(this, (SchemaStringInvalid.__proto__ || Object.getPrototypeOf(SchemaStringInvalid)).apply(this, arguments));
  }

  _createClass(SchemaStringInvalid, [{
    key: 'fieldType',
    get: function get() {
      return 'string';
    }
  }]);

  return SchemaStringInvalid;
}(SchemaFieldInvalid);

var SchemaDateInvalid = function (_SchemaFieldInvalid5) {
  _inherits(SchemaDateInvalid, _SchemaFieldInvalid5);

  function SchemaDateInvalid() {
    _classCallCheck(this, SchemaDateInvalid);

    return _possibleConstructorReturn(this, (SchemaDateInvalid.__proto__ || Object.getPrototypeOf(SchemaDateInvalid)).apply(this, arguments));
  }

  _createClass(SchemaDateInvalid, [{
    key: 'fieldType',
    get: function get() {
      return 'date';
    }
  }]);

  return SchemaDateInvalid;
}(SchemaFieldInvalid);

var SchemaListInvalid = function (_SchemaFieldInvalid6) {
  _inherits(SchemaListInvalid, _SchemaFieldInvalid6);

  function SchemaListInvalid() {
    _classCallCheck(this, SchemaListInvalid);

    return _possibleConstructorReturn(this, (SchemaListInvalid.__proto__ || Object.getPrototypeOf(SchemaListInvalid)).apply(this, arguments));
  }

  _createClass(SchemaListInvalid, [{
    key: 'fieldType',
    get: function get() {
      return 'list';
    }
  }]);

  return SchemaListInvalid;
}(SchemaFieldInvalid);

var SchemaMapInvalid = function (_SchemaFieldInvalid7) {
  _inherits(SchemaMapInvalid, _SchemaFieldInvalid7);

  function SchemaMapInvalid() {
    _classCallCheck(this, SchemaMapInvalid);

    return _possibleConstructorReturn(this, (SchemaMapInvalid.__proto__ || Object.getPrototypeOf(SchemaMapInvalid)).apply(this, arguments));
  }

  _createClass(SchemaMapInvalid, [{
    key: 'fieldType',
    get: function get() {
      return 'map';
    }
  }]);

  return SchemaMapInvalid;
}(SchemaFieldInvalid);

var SchemaSchemaInvalid = function (_SchemaFieldInvalid8) {
  _inherits(SchemaSchemaInvalid, _SchemaFieldInvalid8);

  function SchemaSchemaInvalid() {
    _classCallCheck(this, SchemaSchemaInvalid);

    return _possibleConstructorReturn(this, (SchemaSchemaInvalid.__proto__ || Object.getPrototypeOf(SchemaSchemaInvalid)).apply(this, arguments));
  }

  _createClass(SchemaSchemaInvalid, [{
    key: 'fieldType',
    get: function get() {
      return this.field.displayName;
    }
  }]);

  return SchemaSchemaInvalid;
}(SchemaFieldInvalid);

var SchemaKeysUnknown = function (_SchemaValidationErro2) {
  _inherits(SchemaKeysUnknown, _SchemaValidationErro2);

  function SchemaKeysUnknown(field, value, keys) {
    _classCallCheck(this, SchemaKeysUnknown);

    var _this10 = _possibleConstructorReturn(this, (SchemaKeysUnknown.__proto__ || Object.getPrototypeOf(SchemaKeysUnknown)).call(this, field, value));

    _this10.unknownKeys = keys;
    return _this10;
  }

  _createClass(SchemaKeysUnknown, [{
    key: 'getMessage',
    value: function getMessage() {
      return 'contains unknown keys ' + this.unknownKeys;
    }
  }, {
    key: 'values',
    get: function get() {
      var ret = _get(SchemaKeysUnknown.prototype.__proto__ || Object.getPrototypeOf(SchemaKeysUnknown.prototype), 'values', this);
      ret['unknownKeys'] = this.unknownKeys;
      return ret;
    }
  }]);

  return SchemaKeysUnknown;
}(SchemaValidationError);

var SchemaReferencePending = function () {
  function SchemaReferencePending() {
    _classCallCheck(this, SchemaReferencePending);
  }

  _createClass(SchemaReferencePending, [{
    key: 'toString',
    value: function toString() {
      return "Waiting for reference to finish loading.";
    }
  }]);

  return SchemaReferencePending;
}();

/*********************************************************************************************************************
 * SPECIFIER ERRORS
 *********************************************************************************************************************/


var SchemaOutOfRange = function (_SchemaValidationErro3) {
  _inherits(SchemaOutOfRange, _SchemaValidationErro3);

  function SchemaOutOfRange(field, value, min, max) {
    _classCallCheck(this, SchemaOutOfRange);

    var _this11 = _possibleConstructorReturn(this, (SchemaOutOfRange.__proto__ || Object.getPrototypeOf(SchemaOutOfRange)).call(this, field, value));

    _this11.min = min;
    _this11.max = max;
    return _this11;
  }

  _createClass(SchemaOutOfRange, [{
    key: 'getMessage',
    value: function getMessage() {
      if (this.min !== undefined && this.max !== undefined) {
        return 'should be between ' + this.min + ' and ' + this.max;
      } else if (this.min !== undefined) {
        return 'should be greater than or equal to ' + this.min;
      } else if (this.max !== undefined) {
        return 'should be less than or equal to ' + this.max;
      } else {
        return this.field.getMessage();
      }
    }
  }, {
    key: 'values',
    get: function get() {
      var ret = _get(SchemaOutOfRange.prototype.__proto__ || Object.getPrototypeOf(SchemaOutOfRange.prototype), 'values', this);
      ret['min'] = this.min;
      ret['max'] = this.max;
      return ret;
    }
  }]);

  return SchemaOutOfRange;
}(SchemaValidationError);

var SchemaRangeInvalid = function (_SchemaOutOfRange) {
  _inherits(SchemaRangeInvalid, _SchemaOutOfRange);

  function SchemaRangeInvalid() {
    _classCallCheck(this, SchemaRangeInvalid);

    return _possibleConstructorReturn(this, (SchemaRangeInvalid.__proto__ || Object.getPrototypeOf(SchemaRangeInvalid)).apply(this, arguments));
  }

  return SchemaRangeInvalid;
}(SchemaOutOfRange);

var SchemaRangeInvalidBelowMin = function (_SchemaRangeInvalid) {
  _inherits(SchemaRangeInvalidBelowMin, _SchemaRangeInvalid);

  function SchemaRangeInvalidBelowMin() {
    _classCallCheck(this, SchemaRangeInvalidBelowMin);

    return _possibleConstructorReturn(this, (SchemaRangeInvalidBelowMin.__proto__ || Object.getPrototypeOf(SchemaRangeInvalidBelowMin)).apply(this, arguments));
  }

  return SchemaRangeInvalidBelowMin;
}(SchemaRangeInvalid);

var SchemaRangeInvalidAboveMax = function (_SchemaRangeInvalid2) {
  _inherits(SchemaRangeInvalidAboveMax, _SchemaRangeInvalid2);

  function SchemaRangeInvalidAboveMax() {
    _classCallCheck(this, SchemaRangeInvalidAboveMax);

    return _possibleConstructorReturn(this, (SchemaRangeInvalidAboveMax.__proto__ || Object.getPrototypeOf(SchemaRangeInvalidAboveMax)).apply(this, arguments));
  }

  return SchemaRangeInvalidAboveMax;
}(SchemaRangeInvalid);

// Type specific errors


var SchemaNumberBelowMin = function (_SchemaOutOfRange2) {
  _inherits(SchemaNumberBelowMin, _SchemaOutOfRange2);

  function SchemaNumberBelowMin() {
    _classCallCheck(this, SchemaNumberBelowMin);

    return _possibleConstructorReturn(this, (SchemaNumberBelowMin.__proto__ || Object.getPrototypeOf(SchemaNumberBelowMin)).apply(this, arguments));
  }

  return SchemaNumberBelowMin;
}(SchemaOutOfRange);

var SchemaNumberAboveMax = function (_SchemaOutOfRange3) {
  _inherits(SchemaNumberAboveMax, _SchemaOutOfRange3);

  function SchemaNumberAboveMax() {
    _classCallCheck(this, SchemaNumberAboveMax);

    return _possibleConstructorReturn(this, (SchemaNumberAboveMax.__proto__ || Object.getPrototypeOf(SchemaNumberAboveMax)).apply(this, arguments));
  }

  return SchemaNumberAboveMax;
}(SchemaOutOfRange);

var SchemaIntegerBelowMin = function (_SchemaOutOfRange4) {
  _inherits(SchemaIntegerBelowMin, _SchemaOutOfRange4);

  function SchemaIntegerBelowMin() {
    _classCallCheck(this, SchemaIntegerBelowMin);

    return _possibleConstructorReturn(this, (SchemaIntegerBelowMin.__proto__ || Object.getPrototypeOf(SchemaIntegerBelowMin)).apply(this, arguments));
  }

  return SchemaIntegerBelowMin;
}(SchemaOutOfRange);

var SchemaIntegerAboveMax = function (_SchemaOutOfRange5) {
  _inherits(SchemaIntegerAboveMax, _SchemaOutOfRange5);

  function SchemaIntegerAboveMax() {
    _classCallCheck(this, SchemaIntegerAboveMax);

    return _possibleConstructorReturn(this, (SchemaIntegerAboveMax.__proto__ || Object.getPrototypeOf(SchemaIntegerAboveMax)).apply(this, arguments));
  }

  return SchemaIntegerAboveMax;
}(SchemaOutOfRange);

var SchemaSizeUnknown = function (_SchemaValidationErro4) {
  _inherits(SchemaSizeUnknown, _SchemaValidationErro4);

  function SchemaSizeUnknown() {
    _classCallCheck(this, SchemaSizeUnknown);

    return _possibleConstructorReturn(this, (SchemaSizeUnknown.__proto__ || Object.getPrototypeOf(SchemaSizeUnknown)).apply(this, arguments));
  }

  _createClass(SchemaSizeUnknown, [{
    key: 'getMessage',
    value: function getMessage() {
      return 'Unable to get size from ' + this.value;
    }
  }]);

  return SchemaSizeUnknown;
}(SchemaValidationError);

var SchemaSizeOutOfRange = function (_SchemaValidationErro5) {
  _inherits(SchemaSizeOutOfRange, _SchemaValidationErro5);

  function SchemaSizeOutOfRange(field, value, min, max) {
    _classCallCheck(this, SchemaSizeOutOfRange);

    var _this20 = _possibleConstructorReturn(this, (SchemaSizeOutOfRange.__proto__ || Object.getPrototypeOf(SchemaSizeOutOfRange)).call(this, field, value));

    _this20.min = min;
    _this20.max = max;
    return _this20;
  }

  _createClass(SchemaSizeOutOfRange, [{
    key: 'getMessage',
    value: function getMessage() {
      if (this.min !== undefined && this.max !== undefined) {
        if (this.field instanceof StringField) {
          return 'should be between ' + this.min + ' and ' + this.max + ' characters';
        } else {
          return 'should have size between ' + this.min + ' and ' + this.max;
        }
      } else if (this.min !== undefined) {
        if (this.field instanceof StringField) {
          return 'should have at least ' + this.min + ' characters';
        } else {
          return 'should have size greater than or equal to ' + this.min;
        }
      } else if (this.max !== undefined) {
        if (this.field instanceof StringField) {
          return 'should have no more than ' + this.max + ' characters';
        } else {
          return 'should have size less than or equal to ' + this.max;
        }
      } else {
        return this.field.getMessage();
      }
    }
  }, {
    key: 'values',
    get: function get() {
      var ret = _get(SchemaSizeOutOfRange.prototype.__proto__ || Object.getPrototypeOf(SchemaSizeOutOfRange.prototype), 'values', this);
      ret['min'] = this.min;
      ret['max'] = this.max;
      return ret;
    }
  }]);

  return SchemaSizeOutOfRange;
}(SchemaValidationError);

var SchemaSizeInvalid = function (_SchemaSizeOutOfRange) {
  _inherits(SchemaSizeInvalid, _SchemaSizeOutOfRange);

  function SchemaSizeInvalid() {
    _classCallCheck(this, SchemaSizeInvalid);

    return _possibleConstructorReturn(this, (SchemaSizeInvalid.__proto__ || Object.getPrototypeOf(SchemaSizeInvalid)).apply(this, arguments));
  }

  return SchemaSizeInvalid;
}(SchemaSizeOutOfRange);

var SchemaSizeInvalidBelowMin = function (_SchemaSizeInvalid) {
  _inherits(SchemaSizeInvalidBelowMin, _SchemaSizeInvalid);

  function SchemaSizeInvalidBelowMin() {
    _classCallCheck(this, SchemaSizeInvalidBelowMin);

    return _possibleConstructorReturn(this, (SchemaSizeInvalidBelowMin.__proto__ || Object.getPrototypeOf(SchemaSizeInvalidBelowMin)).apply(this, arguments));
  }

  return SchemaSizeInvalidBelowMin;
}(SchemaSizeInvalid);

var SchemaSizeInvalidAboveMax = function (_SchemaSizeInvalid2) {
  _inherits(SchemaSizeInvalidAboveMax, _SchemaSizeInvalid2);

  function SchemaSizeInvalidAboveMax() {
    _classCallCheck(this, SchemaSizeInvalidAboveMax);

    return _possibleConstructorReturn(this, (SchemaSizeInvalidAboveMax.__proto__ || Object.getPrototypeOf(SchemaSizeInvalidAboveMax)).apply(this, arguments));
  }

  return SchemaSizeInvalidAboveMax;
}(SchemaSizeInvalid);

// Type specific errors


var SchemaStringBelowMinLength = function (_SchemaSizeOutOfRange2) {
  _inherits(SchemaStringBelowMinLength, _SchemaSizeOutOfRange2);

  function SchemaStringBelowMinLength() {
    _classCallCheck(this, SchemaStringBelowMinLength);

    return _possibleConstructorReturn(this, (SchemaStringBelowMinLength.__proto__ || Object.getPrototypeOf(SchemaStringBelowMinLength)).apply(this, arguments));
  }

  return SchemaStringBelowMinLength;
}(SchemaSizeOutOfRange);

var SchemaStringAboveMaxLength = function (_SchemaSizeOutOfRange3) {
  _inherits(SchemaStringAboveMaxLength, _SchemaSizeOutOfRange3);

  function SchemaStringAboveMaxLength() {
    _classCallCheck(this, SchemaStringAboveMaxLength);

    return _possibleConstructorReturn(this, (SchemaStringAboveMaxLength.__proto__ || Object.getPrototypeOf(SchemaStringAboveMaxLength)).apply(this, arguments));
  }

  return SchemaStringAboveMaxLength;
}(SchemaSizeOutOfRange);

var SchemaNotOneOf = function (_SchemaValidationErro6) {
  _inherits(SchemaNotOneOf, _SchemaValidationErro6);

  function SchemaNotOneOf(field, value, oneOf) {
    _classCallCheck(this, SchemaNotOneOf);

    var _this26 = _possibleConstructorReturn(this, (SchemaNotOneOf.__proto__ || Object.getPrototypeOf(SchemaNotOneOf)).call(this, field, value));

    _this26.oneOf = oneOf;
    return _this26;
  }

  _createClass(SchemaNotOneOf, [{
    key: 'getMessage',
    value: function getMessage() {
      if (this.oneOf !== undefined) {
        return 'should be one of ' + JSON.stringify(this.oneOf);
      } else {
        return this.field.getMessage();
      }
    }
  }, {
    key: 'values',
    get: function get() {
      var ret = _get(SchemaNotOneOf.prototype.__proto__ || Object.getPrototypeOf(SchemaNotOneOf.prototype), 'values', this);
      ret['oneOf'] = this.oneOf;
      return ret;
    }
  }]);

  return SchemaNotOneOf;
}(SchemaValidationError);

var SchemaStringNotOneOf = function (_SchemaNotOneOf) {
  _inherits(SchemaStringNotOneOf, _SchemaNotOneOf);

  function SchemaStringNotOneOf() {
    _classCallCheck(this, SchemaStringNotOneOf);

    return _possibleConstructorReturn(this, (SchemaStringNotOneOf.__proto__ || Object.getPrototypeOf(SchemaStringNotOneOf)).apply(this, arguments));
  }

  return SchemaStringNotOneOf;
}(SchemaNotOneOf);

/*********************************************************************************************************************
 * FIELDS
 *********************************************************************************************************************/


var ValidationResult = exports.ValidationResult = (0, _immutable.Record)({ path: undefined, extra: undefined, result: undefined });

var SchemaField = function () {
  function SchemaField() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SchemaField);

    this.options = options;

    this.specifiers = (0, _immutable.List)();
  }

  _createClass(SchemaField, [{
    key: 'duplicate',
    value: function duplicate() {
      return new this.constructor();
    }
  }, {
    key: 'specify',
    value: function specify(specifiers) {
      var ret = this.duplicate();

      if (Array.isArray(specifiers) || _immutable.List.isList(specifiers)) {
        ret.specifiers = ret.specifiers.concat(specifiers);
      } else {
        ret.specifiers = ret.specifiers.push(specifiers);
      }
      return ret;
    }
  }, {
    key: 'find',


    /*
     * FIND
     *
     * Function that walks the hierarchy to find a specific schema field based on a key path based on the data present.
     * Find is a static search.  So any dynamic containers will be searched with their null state.  If any errors are
     * present in the key path then an exception is thrown.
     */
    value: function find(keyPath) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!_immutable.List.isList(keyPath)) {
        keyPath = (0, _immutable.List)(keyPath);
      }
      return this.findWalk(keyPath, options);
    }

    /*
     * FIND WALK
     *
     * Override in each SchemaField that is a container.
     */
    //noinspection JSMethodCanBeStatic

  }, {
    key: 'findWalk',
    value: function findWalk(keyPath) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      throw new Error("Schema field find is not yet made for this SchemaField, and is only supported by containers.");
    }

    /*
     * DEFAULT IMMUTABLE RECORD VALUE
     *
     * Default value to use when creating immutable records
     */
    //noinspection JSMethodCanBeStatic

  }, {
    key: 'toImmutable',
    value: function toImmutable(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.toImmutableWalk(data, options);
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: 'toImmutableWalk',
    value: function toImmutableWalk(data, options) {
      throw new Error("Immutable creation is not yet made for this SchemaField");
    }

    /*
     * Returns the error condition used for get a value isn't found in the key path.
     */
    //noinspection JSMethodCanBeStatic

  }, {
    key: 'get',


    /*
     * GET
     *
     * Function that walks the hierarchy to find the data in the hierarchy, but also the field being used.  Returns
     * an array with 2 elements.  First is the field, second is the data.  If there are any errors while walking the path
     * then an undefined pair of [undefined, undefined] will be returned.
     */
    value: function get(data, keyPath) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (data === undefined || data === null) {
        return this._getUndefinedPair;
      }

      var _options$extra = options.extra,
          extra = _options$extra === undefined ? _immutable.Map : _options$extra,
          _options$dataStack = options.dataStack,
          dataStack = _options$dataStack === undefined ? (0, _immutable.List)() : _options$dataStack;


      if (!_immutable.List.isList(keyPath)) {
        if (keyPath === undefined) {
          keyPath = (0, _immutable.List)();
        } else {
          keyPath = (0, _immutable.List)(keyPath);
        }
      }

      return this.getWalk(data, keyPath, _extends({}, options, { extra: extra, dataStack: dataStack }));
    }

    // Shortcut to avoid the 2-tuple system

  }, {
    key: 'getField',
    value: function getField(data, keyPath, options) {
      var _get2 = this.get(data, keyPath, options),
          _get3 = _slicedToArray(_get2, 2),
          field = _get3[0],
          result = _get3[1];

      return field;
    }

    // Shortcut to avoid the 2-tuple system

  }, {
    key: 'getValue',
    value: function getValue(data, keyPath, options) {
      var _get4 = this.get(data, keyPath, options),
          _get5 = _slicedToArray(_get4, 2),
          field = _get5[0],
          result = _get5[1];

      return result;
    }

    /*
     * GET WALK
     *
     * Override in each SchemaField that is a container.
     */
    //noinspection JSMethodCanBeStatic

  }, {
    key: 'getWalk',
    value: function getWalk(data, keyPath, options) {
      throw new Error("Schema field find is not yet made for this SchemaField, and is only supported by containers.");
    }

    /*
     * WILL ACCEPT
     *
     * Short circuits the validation by only finding the first error, if there is one.  If no error is found then it
     * assumes that value is valid.
     */

  }, {
    key: 'willAccept',
    value: function willAccept(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var gen = this.validateWalk(data, options);
      var first = gen.next();
      return first['done'];
    }

    /*
     * FIRST INVALID
     *
     * Return the first invalid error instance
     */

  }, {
    key: 'firstInvalid',
    value: function firstInvalid(data, options) {
      var gen = this.validateWalk(data, options);
      var firstGen = gen.next();
      if (!firstGen['done']) {
        var first = firstGen['value'];
        return first;
      } else {
        return null;
      }
    }

    /*
     * VALIDATE LIST
     *
     * Return all validation results for a value as a List, and optionally tag them with path and extra information
     */

  }, {
    key: 'validateList',
    value: function validateList(data, options) {
      if (!data) {
        throw new Error('Invalid data for validateMap.  Data: ' + data);
      }

      return (0, _immutable.List)(this.validateWalk(data, options));
    }

    /*
     * VALIDATE MAP
     *
     * Return all validation results for a value as a Map, and optionally tag them with path and extra information
     */

  }, {
    key: 'validateMap',
    value: function validateMap(data, options) {
      if (!this.isContainer && (!options || options['path'] === undefined)) {
        throw new Error("Non-container must have a path argument when using validateMap");
      }
      if (!data) {
        throw new Error('Invalid data for validateMap.  Data: ' + data);
      }

      var ret = (0, _immutable.Map)();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var validation = _step.value;

          if (validation.path.size === 0) {
            throw new Error('Invalid validation path for ' + data);
          }
          ret = ret.updateIn(validation.path, function (results) {
            return results === undefined ? (0, _immutable.List)([validation.result]) : results.push(validation.result);
          });
        };

        for (var _iterator = this.validateWalk(data, options)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return ret;
    }

    /*
     * VALIDATE WALK
     *
     * Generator that walks through all validation errors for this instance.  It starts at the modifier (to allow
     * modifiers to override behaviour).  When all the modifiers have been processed and the walk bottoms out on the
     * base field then validateBase will be calle,, so long as the modifiers used along the walk continue the call chain
     * dispatch.  If that process completes without without an error then the specifiers are walked to produce more
     * specific errors that might exist for an otherwise valid base type.
     */

  }, {
    key: 'validateWalk',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateWalk(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _options$path, path, _options$extra2, extra, _options$dataStack2, dataStack, hasError, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _result, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, specifier, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, result;

      return regeneratorRuntime.wrap(function validateWalk$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _options$path = options.path, path = _options$path === undefined ? (0, _immutable.List)() : _options$path, _options$extra2 = options.extra, extra = _options$extra2 === undefined ? (0, _immutable.Map)() : _options$extra2, _options$dataStack2 = options.dataStack, dataStack = _options$dataStack2 === undefined ? (0, _immutable.List)() : _options$dataStack2;
              hasError = false;
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 5;
              _iterator2 = this.validateModifier(data, _extends({}, options, { path: path, extra: extra, dataStack: dataStack }))[Symbol.iterator]();

            case 7:
              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                _context.next = 20;
                break;
              }

              _result = _step2.value;

              if (!(_result instanceof ValidationResult)) {
                _context.next = 14;
                break;
              }

              _context.next = 12;
              return _result;

            case 12:
              _context.next = 16;
              break;

            case 14:
              _context.next = 16;
              return ValidationResult({ path: path, extra: extra, result: _result });

            case 16:
              hasError = true;

            case 17:
              _iteratorNormalCompletion2 = true;
              _context.next = 7;
              break;

            case 20:
              _context.next = 26;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context['catch'](5);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t0;

            case 26:
              _context.prev = 26;
              _context.prev = 27;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 29:
              _context.prev = 29;

              if (!_didIteratorError2) {
                _context.next = 32;
                break;
              }

              throw _iteratorError2;

            case 32:
              return _context.finish(29);

            case 33:
              return _context.finish(26);

            case 34:
              if (hasError) {
                _context.next = 90;
                break;
              }

              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context.prev = 38;
              _iterator3 = this.specifiers[Symbol.iterator]();

            case 40:
              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                _context.next = 76;
                break;
              }

              specifier = _step3.value;
              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context.prev = 45;
              _iterator4 = specifier.validateSpecifier(this, data, _extends({}, options, { path: path, extra: extra, dataStack: dataStack }))[Symbol.iterator]();

            case 47:
              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                _context.next = 59;
                break;
              }

              result = _step4.value;

              if (!(result instanceof ValidationResult)) {
                _context.next = 54;
                break;
              }

              _context.next = 52;
              return result;

            case 52:
              _context.next = 56;
              break;

            case 54:
              _context.next = 56;
              return ValidationResult({ path: path, extra: extra, result: result });

            case 56:
              _iteratorNormalCompletion4 = true;
              _context.next = 47;
              break;

            case 59:
              _context.next = 65;
              break;

            case 61:
              _context.prev = 61;
              _context.t1 = _context['catch'](45);
              _didIteratorError4 = true;
              _iteratorError4 = _context.t1;

            case 65:
              _context.prev = 65;
              _context.prev = 66;

              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }

            case 68:
              _context.prev = 68;

              if (!_didIteratorError4) {
                _context.next = 71;
                break;
              }

              throw _iteratorError4;

            case 71:
              return _context.finish(68);

            case 72:
              return _context.finish(65);

            case 73:
              _iteratorNormalCompletion3 = true;
              _context.next = 40;
              break;

            case 76:
              _context.next = 82;
              break;

            case 78:
              _context.prev = 78;
              _context.t2 = _context['catch'](38);
              _didIteratorError3 = true;
              _iteratorError3 = _context.t2;

            case 82:
              _context.prev = 82;
              _context.prev = 83;

              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }

            case 85:
              _context.prev = 85;

              if (!_didIteratorError3) {
                _context.next = 88;
                break;
              }

              throw _iteratorError3;

            case 88:
              return _context.finish(85);

            case 89:
              return _context.finish(82);

            case 90:
            case 'end':
              return _context.stop();
          }
        }
      }, validateWalk, this, [[5, 22, 26, 34], [27,, 29, 33], [38, 78, 82, 90], [45, 61, 65, 73], [66,, 68, 72], [83,, 85, 89]]);
    })

    /*
     * VALIDATE MODIFIER
     *
     * Can be overidden by modifiers so that they can override the call chain and avoid base field validations.
     * Overidden modifiers should generally call the `validateModifier` method of the wrapped field.  When the unmodified
     * field is eventually reach, this call in the base class will walk `validateBase` to get the field level errors.
     *
     * Example:
     *
     *   *validateModifier(value) {
     *     if (!overrideCondition) {
     *       yield* this.field.validateModifier(value);
     *     }
     *   }
     *
     */

  }, {
    key: 'validateModifier',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateModifier(data, options) {
      return regeneratorRuntime.wrap(function validateModifier$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.delegateYield(this.validateBase(data, options), 't0', 1);

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, validateModifier, this);
    })

    /*
     * VALIDATE BASE
     *
     * Override to validate what would be considered an unmodified basic field type
     */

  }, {
    key: 'validateBase',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateBase(data, options) {
      return regeneratorRuntime.wrap(function validateBase$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
            case 'end':
              return _context3.stop();
          }
        }
      }, validateBase, this);
    })
  }, {
    key: 'modifiers',
    get: function get() {
      return [];
    }
  }, {
    key: 'specifierTypes',
    get: function get() {
      return this.specifiers.map(function (s) {
        return s.type;
      }).toArray();
    }
  }, {
    key: 'modifierType',
    get: function get() {
      // See SchemaModifier
      throw new Error("Override modifierType");
    }
  }, {
    key: 'type',
    get: function get() {
      throw new Error("Override with type");
    }
  }, {
    key: 'isContainer',
    get: function get() {
      return false;
    }
  }, {
    key: 'isDynamicContainer',
    get: function get() {
      return false;
    }
  }, {
    key: 'isModifier',
    get: function get() {
      return this.modifiers.size > 0;
    }
  }, {
    key: 'hasSpecifiers',
    get: function get() {
      return this.specifiers.size > 0;
    }
  }, {
    key: 'toImmutableDefaultValue',
    get: function get() {
      return undefined;
    }
  }, {
    key: '_getUndefinedPair',
    get: function get() {
      return [undefined, undefined];
    }
  }]);

  return SchemaField;
}();

/*********************************************************************************************************************
 * FIELD PRIMITIVES
 *********************************************************************************************************************/


var SchemaFieldPrimitive = function (_SchemaField) {
  _inherits(SchemaFieldPrimitive, _SchemaField);

  function SchemaFieldPrimitive() {
    _classCallCheck(this, SchemaFieldPrimitive);

    return _possibleConstructorReturn(this, (SchemaFieldPrimitive.__proto__ || Object.getPrototypeOf(SchemaFieldPrimitive)).apply(this, arguments));
  }

  _createClass(SchemaFieldPrimitive, [{
    key: 'toImmutableWalk',
    value: function toImmutableWalk(data, options) {
      return data;
    }
  }, {
    key: 'getWalk',


    /*
     * GET (WALK)
     *
     * Internal function to walk through the schema and locate a particular field and it's associated data
     */
    value: function getWalk(data, keyPath, options) {
      if (keyPath.isEmpty()) {
        return [this, data];
      } else {
        return this._getUndefinedPair;
      }
    }
  }, {
    key: 'toImmutableDefaultValue',
    get: function get() {
      return this.options['default'];
    }
  }]);

  return SchemaFieldPrimitive;
}(SchemaField);

/*
 * NUMBER
 *
 * NOTE: For pragmatic reasons min/max is defined on the Number so that it can be generically accessed
 *       by attributes.  The Ranged() specifier still works, but might be less convenient for numbers.
 */


var NumberField = function (_SchemaFieldPrimitive) {
  _inherits(NumberField, _SchemaFieldPrimitive);

  function NumberField(options) {
    _classCallCheck(this, NumberField);

    var _this29 = _possibleConstructorReturn(this, (NumberField.__proto__ || Object.getPrototypeOf(NumberField)).call(this, options));

    var _this29$options = _this29.options,
        _this29$options$min = _this29$options.min,
        min = _this29$options$min === undefined ? undefined : _this29$options$min,
        _this29$options$max = _this29$options.max,
        max = _this29$options$max === undefined ? undefined : _this29$options$max;


    _this29.min = min;
    _this29.max = max;
    return _this29;
  }

  _createClass(NumberField, [{
    key: 'validateBase',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateBase(data, options) {
      return regeneratorRuntime.wrap(function validateBase$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.constructor.isNumber(data)) {
                _context4.next = 11;
                break;
              }

              if (!(this.min !== undefined && data < this.min)) {
                _context4.next = 6;
                break;
              }

              _context4.next = 4;
              return new SchemaNumberBelowMin(this, data, this.min, this.max);

            case 4:
              _context4.next = 9;
              break;

            case 6:
              if (!(this.max !== undefined && data > this.max)) {
                _context4.next = 9;
                break;
              }

              _context4.next = 9;
              return new SchemaNumberAboveMax(this, data, this.min, this.max);

            case 9:
              _context4.next = 13;
              break;

            case 11:
              _context4.next = 13;
              return new SchemaNumberInvalid(this, data);

            case 13:
            case 'end':
              return _context4.stop();
          }
        }
      }, validateBase, this);
    })
  }, {
    key: 'type',
    get: function get() {
      return 'number';
    }
  }], [{
    key: 'isNumber',
    value: function isNumber(value) {
      return (typeof value === 'number' || value instanceof Number) && isFinite(value);
    }
  }]);

  return NumberField;
}(SchemaFieldPrimitive);

function getNumberField(options) {
  return new NumberField(options);
}

/*
 * INTEGER
 *
 * NOTE: Same as number, but a little more specific
 */

var IntegerField = function (_NumberField) {
  _inherits(IntegerField, _NumberField);

  function IntegerField() {
    _classCallCheck(this, IntegerField);

    return _possibleConstructorReturn(this, (IntegerField.__proto__ || Object.getPrototypeOf(IntegerField)).apply(this, arguments));
  }

  _createClass(IntegerField, [{
    key: 'validateBase',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateBase(data, options) {
      return regeneratorRuntime.wrap(function validateBase$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!this.constructor.isInteger(data)) {
                _context5.next = 11;
                break;
              }

              if (!(this.min !== undefined && data < this.min)) {
                _context5.next = 6;
                break;
              }

              _context5.next = 4;
              return new SchemaIntegerBelowMin(this, data, this.min, this.max);

            case 4:
              _context5.next = 9;
              break;

            case 6:
              if (!(this.max !== undefined && data > this.max)) {
                _context5.next = 9;
                break;
              }

              _context5.next = 9;
              return new SchemaIntegerAboveMax(this, data, this.min, this.max);

            case 9:
              _context5.next = 13;
              break;

            case 11:
              _context5.next = 13;
              return new SchemaIntegerInvalid(this, data);

            case 13:
            case 'end':
              return _context5.stop();
          }
        }
      }, validateBase, this);
    })
  }, {
    key: 'type',
    get: function get() {
      return 'integer';
    }
  }], [{
    key: 'isInteger',
    value: function isInteger(value) {
      return this.isNumber(value) && value % 1 === 0;
    }
  }]);

  return IntegerField;
}(NumberField);

function getIntegerField(options) {
  return new IntegerField(options);
}

/*
 * BOOLEAN
 */

var BooleanField = function (_SchemaFieldPrimitive2) {
  _inherits(BooleanField, _SchemaFieldPrimitive2);

  function BooleanField() {
    _classCallCheck(this, BooleanField);

    return _possibleConstructorReturn(this, (BooleanField.__proto__ || Object.getPrototypeOf(BooleanField)).apply(this, arguments));
  }

  _createClass(BooleanField, [{
    key: 'validateBase',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateBase(data, options) {
      return regeneratorRuntime.wrap(function validateBase$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (this.constructor.isBoolean(data)) {
                _context6.next = 3;
                break;
              }

              _context6.next = 3;
              return new SchemaBooleanInvalid(this, data);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, validateBase, this);
    })
  }, {
    key: 'type',
    get: function get() {
      return 'boolean';
    }
  }], [{
    key: 'isBoolean',
    value: function isBoolean(value) {
      return value === true || value === false;
    }
  }]);

  return BooleanField;
}(SchemaFieldPrimitive);

function getBooleanField(options) {
  return new BooleanField(options);
}

/*
 * STRING
 *
 * NOTE: For pragmatic reasons min/max length is defined on the string so that it can be generically accessed
         by attributes.  The Sized() specifier still works, but might be less convenient for strings.
 */

var StringField = function (_SchemaFieldPrimitive3) {
  _inherits(StringField, _SchemaFieldPrimitive3);

  function StringField(options) {
    _classCallCheck(this, StringField);

    var _this32 = _possibleConstructorReturn(this, (StringField.__proto__ || Object.getPrototypeOf(StringField)).call(this, options));

    var _this32$options = _this32.options,
        _this32$options$min = _this32$options.min,
        min = _this32$options$min === undefined ? undefined : _this32$options$min,
        _this32$options$max = _this32$options.max,
        max = _this32$options$max === undefined ? undefined : _this32$options$max,
        _this32$options$oneOf = _this32$options.oneOf,
        oneOf = _this32$options$oneOf === undefined ? undefined : _this32$options$oneOf;


    _this32.min = min;
    _this32.max = max;
    _this32.oneOf = oneOf ? Array.isArray(oneOf) ? oneOf : [oneOf] : oneOf;
    return _this32;
  }

  _createClass(StringField, [{
    key: 'validateBase',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateBase(data, options) {
      return regeneratorRuntime.wrap(function validateBase$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!this.constructor.isString(data)) {
                _context7.next = 16;
                break;
              }

              if (!(this.min !== undefined && data.length < this.min)) {
                _context7.next = 6;
                break;
              }

              _context7.next = 4;
              return new SchemaStringBelowMinLength(this, data, this.min, this.max);

            case 4:
              _context7.next = 14;
              break;

            case 6:
              if (!(this.max !== undefined && data.length > this.max)) {
                _context7.next = 11;
                break;
              }

              _context7.next = 9;
              return new SchemaStringAboveMaxLength(this, data, this.min, this.max);

            case 9:
              _context7.next = 14;
              break;

            case 11:
              if (!(this.oneOf !== undefined && this.oneOf.indexOf(data) === -1)) {
                _context7.next = 14;
                break;
              }

              _context7.next = 14;
              return new SchemaStringNotOneOf(this, data, this.oneOf);

            case 14:
              _context7.next = 18;
              break;

            case 16:
              _context7.next = 18;
              return new SchemaStringInvalid(this, data);

            case 18:
            case 'end':
              return _context7.stop();
          }
        }
      }, validateBase, this);
    })
  }, {
    key: 'type',
    get: function get() {
      return 'string';
    }
  }], [{
    key: 'isString',
    value: function isString(value) {
      return typeof value === 'string' || value instanceof String;
    }
  }]);

  return StringField;
}(SchemaFieldPrimitive);

function getStringField(options) {
  return new StringField(options);
}

/*
 * DATE
 */
var dateISORegex = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;

var DateField = function (_SchemaFieldPrimitive4) {
  _inherits(DateField, _SchemaFieldPrimitive4);

  function DateField() {
    _classCallCheck(this, DateField);

    return _possibleConstructorReturn(this, (DateField.__proto__ || Object.getPrototypeOf(DateField)).apply(this, arguments));
  }

  _createClass(DateField, [{
    key: 'validateBase',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateBase(data, options) {
      return regeneratorRuntime.wrap(function validateBase$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (this.constructor.isDate(data)) {
                _context8.next = 3;
                break;
              }

              _context8.next = 3;
              return new SchemaDateInvalid(this, data);

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, validateBase, this);
    })
  }, {
    key: 'type',
    get: function get() {
      return 'date';
    }
  }], [{
    key: 'isDate',
    value: function isDate(value) {
      return dateISORegex.test(value);
    }
  }]);

  return DateField;
}(SchemaFieldPrimitive);

function getDateField(options) {
  return new DateField(options);
}

/*
 * ANY
 */

var AnyField = function (_SchemaFieldPrimitive5) {
  _inherits(AnyField, _SchemaFieldPrimitive5);

  function AnyField() {
    _classCallCheck(this, AnyField);

    return _possibleConstructorReturn(this, (AnyField.__proto__ || Object.getPrototypeOf(AnyField)).apply(this, arguments));
  }

  _createClass(AnyField, [{
    key: 'type',
    get: function get() {
      return 'any';
    }
  }]);

  return AnyField;
}(SchemaFieldPrimitive);

function getAnyField(options) {
  return new AnyField(options);
}

/*
 * ANY IMMUTABLE
 *
 * Same as Any(), but will convert all input data into Immutable structures.
 */

var AnyImmutableField = function (_SchemaFieldPrimitive6) {
  _inherits(AnyImmutableField, _SchemaFieldPrimitive6);

  function AnyImmutableField() {
    _classCallCheck(this, AnyImmutableField);

    return _possibleConstructorReturn(this, (AnyImmutableField.__proto__ || Object.getPrototypeOf(AnyImmutableField)).apply(this, arguments));
  }

  _createClass(AnyImmutableField, [{
    key: 'toImmutableWalk',
    value: function toImmutableWalk(data, options) {
      if (data !== undefined && data !== null && ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' || Array.isArray(data))) {
        return (0, _immutable.fromJS)(data);
      } else {
        return _get(AnyImmutableField.prototype.__proto__ || Object.getPrototypeOf(AnyImmutableField.prototype), 'toImmutableWalk', this).call(this, data, options);
      }
    }
  }, {
    key: 'type',
    get: function get() {
      return 'anyImmutable';
    }
  }]);

  return AnyImmutableField;
}(SchemaFieldPrimitive);

function getAnyImmutableField(options) {
  return new AnyImmutableField(options);
}

/*********************************************************************************************************************
 * CONTAINERS
 *********************************************************************************************************************/

var SchemaContainerField = function (_SchemaField2) {
  _inherits(SchemaContainerField, _SchemaField2);

  function SchemaContainerField() {
    _classCallCheck(this, SchemaContainerField);

    return _possibleConstructorReturn(this, (SchemaContainerField.__proto__ || Object.getPrototypeOf(SchemaContainerField)).apply(this, arguments));
  }

  _createClass(SchemaContainerField, [{
    key: 'getDataStack',


    //noinspection JSMethodCanBeStatic
    value: function getDataStack(data, options) {
      var dataStack = options['dataStack'];
      if (dataStack === undefined) {
        return (0, _immutable.List)([data]);
      } else {
        return dataStack.push(data);
      }
    }
  }, {
    key: 'isContainer',
    get: function get() {
      return true;
    }
  }]);

  return SchemaContainerField;
}(SchemaField);

var ListContainer = function (_SchemaContainerField) {
  _inherits(ListContainer, _SchemaContainerField);

  function ListContainer(listElementType) {
    _classCallCheck(this, ListContainer);

    if (!(listElementType instanceof SchemaField)) {
      throw new Error(listElementType + ' is not a SchemaField');
    }

    var _this37 = _possibleConstructorReturn(this, (ListContainer.__proto__ || Object.getPrototypeOf(ListContainer)).call(this));

    _this37.listElementType = listElementType;
    return _this37;
  }

  _createClass(ListContainer, [{
    key: 'duplicate',
    value: function duplicate() {
      return new this.constructor(this.listElementType);
    }
  }, {
    key: 'findWalk',


    /*
     * FIND (WALK)
     *
     * Internal function to walk through the schema and locate a particular field
     */
    value: function findWalk(keyPath, options) {
      keyPath = keyPath.shift();
      if (!keyPath.isEmpty()) {
        return this.listElementType.findWalk(keyPath, options);
      } else {
        return this.listElementType;
      }
    }

    /*
     * TO IMMUTABLE (WALK)
     *
     * Internal function to walk through the schema to produce Immutable.List by calling contained fields recurisvely
     */

  }, {
    key: 'toImmutableWalk',
    value: function toImmutableWalk(data, options) {
      var _options$createContai = options.createContainers,
          createContainers = _options$createContai === undefined ? false : _options$createContai;


      if (!data) {
        if (createContainers) {
          return (0, _immutable.List)();
        } else {
          return undefined;
        }
      }

      var recordData = [];
      try {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = (0, _utils.enumerateArray)(data)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _step5$value = _slicedToArray(_step5.value, 2),
                i = _step5$value[0],
                value = _step5$value[1];

            recordData.push(this.listElementType.toImmutableWalk(value, options));
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      } catch (NotAMap) {
        throw new SchemaListInvalid();
      }
      return (0, _immutable.List)(recordData);
    }

    /*
     * GET (WALK)
     *
     * Internal function to walk through the schema and locate a particular field and it's associated data
     */

  }, {
    key: 'getWalk',
    value: function getWalk(data, keyPath, options) {
      if (keyPath.isEmpty()) {
        return [this, data];
      }
      var keyStep = keyPath.first();
      if (!Number.isInteger(keyStep)) {
        return this._getUndefinedPair;
      }

      // Push onto the data stack
      var listStack = this.getDataStack(data, options);

      // Move to next position by shifting the keyPath
      var value = (0, _utils.getArrayIndex)(data, keyStep);
      if (value === undefined) {
        return this._getUndefinedPair;
      }

      keyPath = keyPath.shift();
      return this.listElementType.getWalk(value, keyPath, _extends({}, options, { dataStack: listStack }));
    }

    /*
     * VALIDATE (BASE)
     *
     * Internal function to walk through the schema and yield any validation errors that are detected
     */

  }, {
    key: 'validateBase',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateBase(data, options) {
      var indexPath, containedField, listStack, path, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, _step6$value, i, value;

      return regeneratorRuntime.wrap(function validateBase$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              indexPath = void 0;
              containedField = this.listElementType;

              // Push onto the data stack

              listStack = this.getDataStack(data, options);
              path = options['path'];
              _context9.prev = 4;
              _iteratorNormalCompletion6 = true;
              _didIteratorError6 = false;
              _iteratorError6 = undefined;
              _context9.prev = 8;
              _iterator6 = (0, _utils.enumerateArray)(data)[Symbol.iterator]();

            case 10:
              if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                _context9.next = 17;
                break;
              }

              _step6$value = _slicedToArray(_step6.value, 2), i = _step6$value[0], value = _step6$value[1];

              indexPath = path.push(i);
              return _context9.delegateYield(containedField.validateWalk(value, _extends({}, options, {
                path: indexPath,
                dataStack: listStack
              })), 't0', 14);

            case 14:
              _iteratorNormalCompletion6 = true;
              _context9.next = 10;
              break;

            case 17:
              _context9.next = 23;
              break;

            case 19:
              _context9.prev = 19;
              _context9.t1 = _context9['catch'](8);
              _didIteratorError6 = true;
              _iteratorError6 = _context9.t1;

            case 23:
              _context9.prev = 23;
              _context9.prev = 24;

              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }

            case 26:
              _context9.prev = 26;

              if (!_didIteratorError6) {
                _context9.next = 29;
                break;
              }

              throw _iteratorError6;

            case 29:
              return _context9.finish(26);

            case 30:
              return _context9.finish(23);

            case 31:
              _context9.next = 37;
              break;

            case 33:
              _context9.prev = 33;
              _context9.t2 = _context9['catch'](4);
              _context9.next = 37;
              return new SchemaListInvalid();

            case 37:
            case 'end':
              return _context9.stop();
          }
        }
      }, validateBase, this, [[4, 33], [8, 19, 23, 31], [24,, 26, 30]]);
    })
  }, {
    key: 'type',
    get: function get() {
      return 'list';
    }
  }]);

  return ListContainer;
}(SchemaContainerField);

function getList() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new (Function.prototype.bind.apply(ListContainer, [null].concat(args)))();
}

var MapContainer = function (_SchemaContainerField2) {
  _inherits(MapContainer, _SchemaContainerField2);

  function MapContainer(mapKeyType, mapValueType, options) {
    _classCallCheck(this, MapContainer);

    if (!(mapKeyType instanceof SchemaField)) {
      throw new Error(mapKeyType + ' is not a SchemaField');
    }
    if (!(mapValueType instanceof SchemaField)) {
      throw new Error(mapValueType + ' is not a SchemaField');
    }

    var _this38 = _possibleConstructorReturn(this, (MapContainer.__proto__ || Object.getPrototypeOf(MapContainer)).call(this, options));

    _this38.mapKeyType = mapKeyType;
    _this38.mapValueType = mapValueType;
    return _this38;
  }

  _createClass(MapContainer, [{
    key: 'duplicate',
    value: function duplicate() {
      return new this.constructor(this.mapKeyType, this.mapValueType);
    }
  }, {
    key: 'findWalk',


    /*
     * FIND (WALK)
     *
     * Internal function to walk through the schema and locate a particular field
     */
    value: function findWalk(keyPath, options) {
      var keyStep = keyPath.first();
      keyPath = keyPath.shift();

      var field = void 0;
      if (keyStep == MAP_KEY) {
        field = this.mapKeyType;
      } else if (keyStep == MAP_VALUE) {
        field = this.mapValueType;
      } else {
        throw new Error('"' + keyStep + '" is an unknown path for a Map.  Please use MAP_KEY or MAP_VALUE');
      }

      keyPath = keyPath.shift();
      if (!keyPath.isEmpty()) {
        return field.findWalk(keyPath, options);
      } else {
        return field;
      }
    }

    /*
     * TO IMMUTABLE (WALK)
     *
     * Internal function to walk through the schema to produce Immutable.Map by calling contained fields recurisvely
     */

  }, {
    key: 'toImmutableWalk',
    value: function toImmutableWalk(data, options) {
      var _this39 = this;

      var _options$createContai2 = options.createContainers,
          createContainers = _options$createContai2 === undefined ? false : _options$createContai2;


      if (!data) {
        // EARLY EXIT: No data, nothing to do.
        if (createContainers) {
          return (0, _immutable.Map)();
        } else {
          return undefined;
        }
      }

      return (0, _immutable.Map)().withMutations(function (map) {
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = (0, _utils.walkMap)(data)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var _step7$value = _slicedToArray(_step7.value, 2),
                key = _step7$value[0],
                value = _step7$value[1];

            var mappedValue = _this39.mapValueType.toImmutableWalk(value, options);
            if (createContainers || mappedValue !== undefined) {
              map.set(_this39.mapKeyType.toImmutableWalk(key, options), mappedValue);
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        return map;
      });
    }

    /*
     * GET (WALK)
     *
     * Internal function to walk through the schema and locate a particular field and it's associated data
     */

  }, {
    key: 'getWalk',
    value: function getWalk(data, keyPath, options) {
      if (keyPath.isEmpty()) {
        return [this, data];
      }
      var keyStep = keyPath.first();
      if (!this.mapKeyType.willAccept(keyStep)) {
        // Invalid type in path.  Don't accept.
        return this._getUndefinedPair;
      }
      if (!(0, _utils.hasMapKey)(data, keyStep)) {
        // Data doesn't have that key
        return this._getUndefinedPair;
      }

      // Push new data on the stack
      var mapStack = this.getDataStack(data, options);

      // Move to next position by shifting the keyPath
      keyPath = keyPath.shift();
      var value = (0, _utils.getMapKey)(data, keyStep);
      return this.mapValueType.getWalk(value, keyPath, _extends({}, options, { dataStack: mapStack }));
    }

    /*
     * VALIDATE (BASE)
     *
     * Internal function to walk through the schema and yield any validation errors that are detected
     */

  }, {
    key: 'validateBase',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateBase(data, options) {
      var keyPath, containedKeyField, containedValueField, mapStack, path, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, _step8$value, key, value;

      return regeneratorRuntime.wrap(function validateBase$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              keyPath = void 0;
              containedKeyField = this.mapKeyType;
              containedValueField = this.mapValueType;

              // Push new data on the stack

              mapStack = this.getDataStack(data, options);

              // Validate all items in the Map

              path = options['path'];
              _iteratorNormalCompletion8 = true;
              _didIteratorError8 = false;
              _iteratorError8 = undefined;
              _context10.prev = 8;
              _iterator8 = (0, _utils.walkMap)(data)[Symbol.iterator]();

            case 10:
              if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
                _context10.next = 18;
                break;
              }

              _step8$value = _slicedToArray(_step8.value, 2), key = _step8$value[0], value = _step8$value[1];

              keyPath = path.push(key);
              return _context10.delegateYield(containedKeyField.validateWalk(key, _extends({}, options, { path: keyPath, dataStack: mapStack })), 't0', 14);

            case 14:
              return _context10.delegateYield(containedValueField.validateWalk(value, _extends({}, options, { path: keyPath, dataStack: mapStack })), 't1', 15);

            case 15:
              _iteratorNormalCompletion8 = true;
              _context10.next = 10;
              break;

            case 18:
              _context10.next = 24;
              break;

            case 20:
              _context10.prev = 20;
              _context10.t2 = _context10['catch'](8);
              _didIteratorError8 = true;
              _iteratorError8 = _context10.t2;

            case 24:
              _context10.prev = 24;
              _context10.prev = 25;

              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }

            case 27:
              _context10.prev = 27;

              if (!_didIteratorError8) {
                _context10.next = 30;
                break;
              }

              throw _iteratorError8;

            case 30:
              return _context10.finish(27);

            case 31:
              return _context10.finish(24);

            case 32:
            case 'end':
              return _context10.stop();
          }
        }
      }, validateBase, this, [[8, 20, 24, 32], [25,, 27, 31]]);
    })
  }, {
    key: 'type',
    get: function get() {
      return 'map';
    }
  }]);

  return MapContainer;
}(SchemaContainerField);

function getMap() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return new (Function.prototype.bind.apply(MapContainer, [null].concat(args)))();
}

var SchemaContainer = function (_SchemaContainerField3) {
  _inherits(SchemaContainer, _SchemaContainerField3);

  function SchemaContainer() {
    var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SchemaContainer);

    var _this40 = _possibleConstructorReturn(this, (SchemaContainer.__proto__ || Object.getPrototypeOf(SchemaContainer)).call(this, options));

    var _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? "schema" : _options$displayName;

    _this40.displayName = displayName;
    _this40.definition = schema;
    return _this40;
  }

  /*
   * BUILD IMMUTABLE RECORD
   *
   * Static helper function to construct an Immutable.Record out of this schema
   */


  _createClass(SchemaContainer, [{
    key: 'duplicate',
    value: function duplicate() {
      return new this.constructor(this.definition);
    }
  }, {
    key: 'findWalk',


    /*
     * FIND (WALK)
     *
     * Internal function to walk through the schema and locate a particular field
     */
    value: function findWalk(keyPath, options) {
      // Lookup the field in the schema
      var keyStep = keyPath.first();
      keyPath = keyPath.shift();
      var field = (0, _utils.getMapKey)(this.definition, keyStep);
      if (field === undefined) {
        throw new Error(keyStep + ' is an unknown field for ' + this.displayName);
      }

      keyPath = keyPath.shift();
      if (!keyPath.isEmpty()) {
        return field.findWalk(keyPath, options);
      } else {
        return field;
      }
    }

    /*
     * TO IMMUTABLE (WALK)
     *
     * Internal function to walk through the schema to produce Immutable.Records by calling contained fields recurisvely
     */

  }, {
    key: 'toImmutableWalk',
    value: function toImmutableWalk(data, options) {
      var _options$createContai3 = options.createContainers,
          createContainers = _options$createContai3 === undefined ? false : _options$createContai3;


      if (!data) {
        if (createContainers) {
          data = {};
        } else {
          return undefined;
        }
      }

      // Process all static keys so that information is available for dynamic containers to switch on
      var field = void 0,
          value = void 0;
      var recordData = {};
      var definition = this.definition;

      // Build all the static entries
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this.staticKeys[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var key = _step9.value;

          field = (0, _utils.getMapKey)(definition, key);
          value = (0, _utils.getMapKey)(data, key);
          recordData[key] = field.toImmutableWalk(value, options);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      var staticRecord = new this.Record(recordData);
      if (this.dynamicKeys.size === 0) {
        // EARLY EXIT: No dynamic keys, so the Record is now complete.
        return staticRecord;
      }

      // Push the data onto the stack
      var staticStack = this.getDataStack(staticRecord, options);

      // Build all the dynamic entries
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = this.dynamicKeys[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var _key3 = _step10.value;

          field = (0, _utils.getMapKey)(definition, _key3);
          value = (0, _utils.getMapKey)(data, _key3);
          recordData[_key3] = field.toImmutableWalk(value, _extends({}, options, { dataStack: staticStack }));
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      return new this.Record(recordData);
    }

    /*
     * GET (WALK)
     *
     * Internal function to walk through the schema and locate a particular field and it's associated data
     */

  }, {
    key: 'getWalk',
    value: function getWalk(data, keyPath, options) {
      if (keyPath.isEmpty()) {
        // EARLY EXIT: If we don't have any keypath left, then we've found the data.
        return [this, data];
      }

      var keyStep = keyPath.first();
      var field = (0, _utils.getMapKey)(this.definition, keyStep);
      if (field === undefined) {
        return this._getUndefinedPair;
      }

      // Push the data onto the stack
      var schemaStack = this.getDataStack(data, options);

      // Move to next position by shifting the keyPath
      keyPath = keyPath.shift();
      var value = (0, _utils.getMapKey)(data, keyStep);
      return field.getWalk(value, keyPath, _extends({}, options, { dataStack: schemaStack }));
    }

    /*
     * VALIDATE (BASE)
     *
     * Internal function to walk through the schema and yield any validation errors that are detected
     */

  }, {
    key: 'validateBase',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateBase(data, options) {
      var _this41 = this;

      var valueKeys, unknownKeys, schemaStack, path, keyPath, containedField, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, key;

      return regeneratorRuntime.wrap(function validateBase$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object')) {
                _context11.next = 4;
                break;
              }

              _context11.next = 3;
              return new SchemaSchemaInvalid(this, data);

            case 3:
              return _context11.abrupt('return');

            case 4:
              valueKeys = [].concat(_toConsumableArray((0, _utils.walkMapKeys)(data)));

              // Check if keys were passed that are not in the schema

              unknownKeys = valueKeys.filter(function (k) {
                return !_this41.keys.has(k);
              });

              if (!(unknownKeys.length > 0)) {
                _context11.next = 9;
                break;
              }

              _context11.next = 9;
              return new SchemaKeysUnknown(data, options, unknownKeys);

            case 9:

              // Create the static record and push it on to the stack
              schemaStack = this.getDataStack(data, options);
              path = options['path'];

              // Check all keys in the schema to see if data is correct

              keyPath = void 0, containedField = void 0;
              _iteratorNormalCompletion11 = true;
              _didIteratorError11 = false;
              _iteratorError11 = undefined;
              _context11.prev = 15;
              _iterator11 = this.keys[Symbol.iterator]();

            case 17:
              if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
                _context11.next = 25;
                break;
              }

              key = _step11.value;

              keyPath = path.push(key);
              containedField = (0, _utils.getMapKey)(this.definition, key);
              return _context11.delegateYield(containedField.validateWalk((0, _utils.getMapKey)(data, key), _extends({}, options, { path: keyPath, dataStack: schemaStack })), 't0', 22);

            case 22:
              _iteratorNormalCompletion11 = true;
              _context11.next = 17;
              break;

            case 25:
              _context11.next = 31;
              break;

            case 27:
              _context11.prev = 27;
              _context11.t1 = _context11['catch'](15);
              _didIteratorError11 = true;
              _iteratorError11 = _context11.t1;

            case 31:
              _context11.prev = 31;
              _context11.prev = 32;

              if (!_iteratorNormalCompletion11 && _iterator11.return) {
                _iterator11.return();
              }

            case 34:
              _context11.prev = 34;

              if (!_didIteratorError11) {
                _context11.next = 37;
                break;
              }

              throw _iteratorError11;

            case 37:
              return _context11.finish(34);

            case 38:
              return _context11.finish(31);

            case 39:
            case 'end':
              return _context11.stop();
          }
        }
      }, validateBase, this, [[15, 27, 31, 39], [32,, 34, 38]]);
    })
  }, {
    key: 'definition',


    /*
     * DEFINITION
     *
     * Record schema definition and do book keeping required for parsing and validating data.
     */
    get: function get() {
      return this._definition;
    },
    set: function set(definition) {
      if (Array.isArray(definition) || (typeof definition === 'undefined' ? 'undefined' : _typeof(definition)) !== 'object') {
        throw new Error('Passed invalid definition to ' + this.displayName + '.   Definition: ' + definition);
      }

      this._definition = definition;

      // Construct record instance
      this.Record = this.constructor._buildImmutableRecord(definition);

      // Construct keys

      var _constructor$_groupKe = this.constructor._groupKeys(definition),
          _constructor$_groupKe2 = _slicedToArray(_constructor$_groupKe, 2),
          staticKeys = _constructor$_groupKe2[0],
          dynamicKeys = _constructor$_groupKe2[1];

      this.staticKeys = staticKeys;
      this.dynamicKeys = dynamicKeys;
      this.keys = staticKeys.union(dynamicKeys);
    }
  }, {
    key: 'type',
    get: function get() {
      return 'schema';
    }
  }], [{
    key: '_buildImmutableRecord',
    value: function _buildImmutableRecord(definition) {
      var elements = {};
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = (0, _utils.walkMap)(definition)[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var _step12$value = _slicedToArray(_step12.value, 2),
              key = _step12$value[0],
              field = _step12$value[1];

          if (!(field instanceof SchemaField)) {
            throw new Error(field + ' is not a SchemaField');
          }

          elements[key] = field.toImmutableDefaultValue;
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }

      return (0, _immutable.Record)(elements);
    }

    /*
     * GROUP KEYS
     *
     * Static helper function to group the keys used in the schema definition into items that will not change based on
     * data and items that are dynamic, and will change based on data.
     */

  }, {
    key: '_groupKeys',
    value: function _groupKeys(definition) {
      var dynamicKeys = [],
          staticKeys = [];

      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = (0, _utils.walkMap)(definition)[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var _step13$value = _slicedToArray(_step13.value, 2),
              key = _step13$value[0],
              field = _step13$value[1];

          if (field.isDynamicContainer) {
            dynamicKeys.push(key);
          } else {
            staticKeys.push(key);
          }
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      return [(0, _immutable.Set)(staticKeys), (0, _immutable.Set)(dynamicKeys)];
    }
  }]);

  return SchemaContainer;
}(SchemaContainerField);

function getSchema() {
  for (var _len3 = arguments.length, args = Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return new (Function.prototype.bind.apply(SchemaContainer, [null].concat(args)))();
}

var PendingSchemaContainerField = function (_SchemaContainerField4) {
  _inherits(PendingSchemaContainerField, _SchemaContainerField4);

  function PendingSchemaContainerField(options) {
    _classCallCheck(this, PendingSchemaContainerField);

    return _possibleConstructorReturn(this, (PendingSchemaContainerField.__proto__ || Object.getPrototypeOf(PendingSchemaContainerField)).call(this, options));
  }

  _createClass(PendingSchemaContainerField, [{
    key: 'duplicate',
    value: function duplicate() {
      return new this.constructor();
    }
  }, {
    key: 'findWalk',


    /*
     * FIND (WALK)
     *
     * Internal function to walk through the schema and locate a particular field
     *
     * WARNING: In Pending this will always stop at the pending schema level, regardless of the
     *          keyPath (because we don't know what the schema looks like yet)
     */
    value: function findWalk(keyPath, options) {
      return this;
    }

    /*
     * TO IMMUTABLE (WALK)
     *
     * Internal function to walk through the schema to produce Immutable.Records by calling contained fields recurisvely
     */

  }, {
    key: 'toImmutableWalk',
    value: function toImmutableWalk(data, options) {
      return (0, _immutable.fromJS)(data);
    }

    /*
     * GET (WALK)
     *
     * Internal function to walk through the schema and locate a particular field and it's associated data
     */

  }, {
    key: 'getWalk',
    value: function getWalk(data, keyPath, options) {
      return (0, _utils.getMapKeyPath)(data, keyPath);
    }
  }, {
    key: 'validateBase',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateBase() {
      return regeneratorRuntime.wrap(function validateBase$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return new SchemaReferencePending();

            case 2:
            case 'end':
              return _context12.stop();
          }
        }
      }, validateBase, this);
    })
  }, {
    key: 'type',
    get: function get() {
      return 'PendingSchema';
    }
  }]);

  return PendingSchemaContainerField;
}(SchemaContainerField);

function getPendingSchema() {
  for (var _len4 = arguments.length, args = Array(_len4), _key5 = 0; _key5 < _len4; _key5++) {
    args[_key5] = arguments[_key5];
  }

  return new (Function.prototype.bind.apply(PendingSchemaContainerField, [null].concat(args)))();
}

/*********************************************************************************************************************
 * DYNAMIC CONTAINERS
 *********************************************************************************************************************/

var SchemaDynamicContainerField = function (_SchemaContainerField5) {
  _inherits(SchemaDynamicContainerField, _SchemaContainerField5);

  function SchemaDynamicContainerField() {
    _classCallCheck(this, SchemaDynamicContainerField);

    return _possibleConstructorReturn(this, (SchemaDynamicContainerField.__proto__ || Object.getPrototypeOf(SchemaDynamicContainerField)).apply(this, arguments));
  }

  _createClass(SchemaDynamicContainerField, [{
    key: 'isDynamicContainer',
    get: function get() {
      return true;
    }
  }]);

  return SchemaDynamicContainerField;
}(SchemaContainerField);

/*
 * DYNAMIC NEIGHBOUR SCHEMA CONTAINER
 *
 * A dynamic schema container allows for a schema to be swapped out for another schema based on the current stack
 * of "neighbour" data (which is all data in the most recent schema) as the data is parsed or validated.
 *
 * The first argument is "nullSchema" which is used for cases where neighbour data is undefined or the callback
 * function given in argument returns `null` or `undefined`.
 *
 * The second argument is a callback function that controls the switching behaviour.  An example is:
 *
 * let SchemaNull = Schema(...);
 * let SchemaOne = Schema(...);
 * let SchemaTwo = Schema(...);
 *
 * function schemaSelector(neighbours, options) {
 *    let typeId = neighbours['type'];
 *    if (typeId === undefined) {
 *      return undefined;
 *    } else if (typeId === null) {
 *      return null;
 *    } else if (typeId === 1) {
 *      return SchemaOne;
 *    } else if (typeId === 2) {
 *      return SchemaTwo;
 *    } else {
 *      throw new Error("Invalid type!")
 *    }
 * }
 *
 * let MyDynamicNeighbourSchema = Schema({
 *   type: Integer(),
 *   different: DynamicNeighbourSchema(SchemaNull, schemaSelector)
 * })
 *
 */


var DynamicNeighbourSchemaContainer = function (_SchemaDynamicContain) {
  _inherits(DynamicNeighbourSchemaContainer, _SchemaDynamicContain);

  function DynamicNeighbourSchemaContainer(nullSchema, dynamicCb, options) {
    _classCallCheck(this, DynamicNeighbourSchemaContainer);

    if (!(nullSchema instanceof SchemaContainerField || nullSchema instanceof MaybeModifier && nullSchema.field instanceof SchemaContainerField)) {
      throw new Error(nullSchema + ' is not a SchemaContainerField');
    }

    var _this44 = _possibleConstructorReturn(this, (DynamicNeighbourSchemaContainer.__proto__ || Object.getPrototypeOf(DynamicNeighbourSchemaContainer)).call(this, options));

    _this44.nullSchema = nullSchema;
    _this44.dynamicCb = dynamicCb;
    return _this44;
  }

  _createClass(DynamicNeighbourSchemaContainer, [{
    key: 'findWalk',


    /*
     * FIND (WALK)
     *
     * Internal function to walk through the schema and locate a particular field
     */
    value: function findWalk(keyPath, options) {
      var schema = this.selectSchema(options);
      return schema.findWalk(keyPath, options);
    }
  }, {
    key: 'selectSchema',
    value: function selectSchema(options) {
      var neighbours = undefined;
      if (options['dataStack'] !== undefined) {
        neighbours = options['dataStack'].last();
      }

      var schema = void 0;
      if (neighbours !== undefined) {
        schema = this.dynamicCb(neighbours, _extends({}, options, { nullSchema: this.nullSchema }));
        if (schema === undefined || schema === null) {
          schema = this.nullSchema;
        }
      } else {
        schema = this.nullSchema;
      }
      return schema;
    }
  }, {
    key: 'toImmutableWalk',
    value: function toImmutableWalk(data, options) {
      var schema = this.selectSchema(options);
      return schema.toImmutableWalk(data, options);
    }

    /*
     * GET (WALK)
     *
     * Internal function to walk through the schema and locate a particular field and it's associated data
     */

  }, {
    key: 'getWalk',
    value: function getWalk(data, keyPath, options) {
      // Determine schema to be used
      var schema = this.selectSchema(options);
      return schema.getWalk(data, keyPath, options);
    }
  }, {
    key: 'validateBase',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateBase(data, options) {
      var schema;
      return regeneratorRuntime.wrap(function validateBase$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              schema = this.selectSchema(options);
              return _context13.delegateYield(schema.validateWalk(data, options), 't0', 2);

            case 2:
            case 'end':
              return _context13.stop();
          }
        }
      }, validateBase, this);
    })
  }, {
    key: 'type',
    get: function get() {
      return 'DynamicNeighbourSchema';
    }
  }]);

  return DynamicNeighbourSchemaContainer;
}(SchemaDynamicContainerField);

function getDynamicNeighbourSchema() {
  for (var _len5 = arguments.length, args = Array(_len5), _key6 = 0; _key6 < _len5; _key6++) {
    args[_key6] = arguments[_key6];
  }

  return new (Function.prototype.bind.apply(DynamicNeighbourSchemaContainer, [null].concat(args)))();
}

/*
 * DYNAMIC INLINE SCHEMA CONTAINER
 *
 * A dynamic schema container allows for a schema to be swapped out for another schema based on the
 * data within the same object.  This is typically used in a structure like:
 *
 * {
 *   type: 1
 *   thing: ...
 * }
 *
 * versus
 *
 * {
 *   type: 2
 *   otherThing: ...
 * }
 *
 * where the "blessed" type key dictates what other data should look like in the same object.  In
 * the example above this switch would dictate using a key of "thing" vs using a key of "otherThing"
 *
 * The first argument is "nullSchema" which is used for cases where neighbour data is undefined
 * or the callback function given in argument returns `null` or `undefined`.
 *
 * The second argument is a callback function that controls the switching behaviour.  An example is:
 *
 * let SchemaNull = Schema(type: Integer(), ...);
 * let SchemaOne = Schema(type: Integer(), ...);
 * let SchemaTwo = Schema(type: Integer(), ...);
 *
 * function schemaSelector(data, options) {
 *    let typeId = data['type'];
 *    if (typeId === undefined) {
 *      return undefined;
 *    } else if (typeId === null) {
 *      return null;
 *    } else if (typeId === 1) {
 *      return SchemaOne;
 *    } else if (typeId === 2) {
 *      return SchemaTwo;
 *    } else {
 *      throw new Error("Invalid type!")
 *    }
 * }
 *
 * let MyDynamicInlineSchema = DynamicInlineSchema(SchemaNull, schemaSelector);
 *
 */

var DynamicInlineSchemaContainer = function (_SchemaDynamicContain2) {
  _inherits(DynamicInlineSchemaContainer, _SchemaDynamicContain2);

  function DynamicInlineSchemaContainer(nullSchema, dynamicCb, options) {
    _classCallCheck(this, DynamicInlineSchemaContainer);

    if (!(nullSchema instanceof SchemaContainerField || nullSchema instanceof MaybeModifier && nullSchema.field instanceof SchemaContainerField)) {
      throw new Error(nullSchema + ' is not a SchemaContainerField');
    }

    var _this45 = _possibleConstructorReturn(this, (DynamicInlineSchemaContainer.__proto__ || Object.getPrototypeOf(DynamicInlineSchemaContainer)).call(this, options));

    _this45.nullSchema = nullSchema;
    _this45.dynamicCb = dynamicCb;
    return _this45;
  }

  _createClass(DynamicInlineSchemaContainer, [{
    key: 'findWalk',


    /*
     * FIND (WALK)
     *
     * Internal function to walk through the schema and locate a particular field
     */
    value: function findWalk(keyPath, options) {
      var schema = this.selectSchema(undefined, options);
      return schema.findWalk(keyPath, options);
    }
  }, {
    key: 'selectSchema',
    value: function selectSchema(data, options) {
      var schema = void 0;
      if (data !== undefined) {
        schema = this.dynamicCb(data, _extends({}, options, { nullSchema: this.nullSchema }));
        if (schema === undefined || schema === null) {
          schema = this.nullSchema;
        }
      } else {
        schema = this.nullSchema;
      }
      return schema;
    }
  }, {
    key: 'toImmutableWalk',
    value: function toImmutableWalk(data, options) {
      var schema = this.selectSchema(data, options);
      return schema.toImmutableWalk(data, options);
    }

    /*
     * GET (WALK)
     *
     * Internal function to walk through the schema and locate a particular field and it's associated data
     */

  }, {
    key: 'getWalk',
    value: function getWalk(data, keyPath, options) {
      // Determine schema to be used
      var schema = this.selectSchema(data, options);
      return schema.getWalk(data, keyPath, options);
    }
  }, {
    key: 'validateBase',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateBase(data, options) {
      var schema;
      return regeneratorRuntime.wrap(function validateBase$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              schema = this.selectSchema(data, options);
              return _context14.delegateYield(schema.validateWalk(data, options), 't0', 2);

            case 2:
            case 'end':
              return _context14.stop();
          }
        }
      }, validateBase, this);
    })
  }, {
    key: 'type',
    get: function get() {
      return 'DynamicInlineSchema';
    }
  }]);

  return DynamicInlineSchemaContainer;
}(SchemaDynamicContainerField);

function getDynamicInlineSchema() {
  for (var _len6 = arguments.length, args = Array(_len6), _key7 = 0; _key7 < _len6; _key7++) {
    args[_key7] = arguments[_key7];
  }

  return new (Function.prototype.bind.apply(DynamicInlineSchemaContainer, [null].concat(args)))();
}

/*********************************************************************************************************************
 * MODIFIERS
 *********************************************************************************************************************/

var SchemaModifier = function (_SchemaField3) {
  _inherits(SchemaModifier, _SchemaField3);

  function SchemaModifier(field, options) {
    _classCallCheck(this, SchemaModifier);

    if (!(field instanceof SchemaField)) {
      throw new Error(field + ' is not a SchemaField');
    }

    var _this46 = _possibleConstructorReturn(this, (SchemaModifier.__proto__ || Object.getPrototypeOf(SchemaModifier)).call(this, options));

    _this46.field = field;

    _this46._masquerade();
    return _this46;
  }

  /*
   * MASQUERADE
   *
   * Since modifiers override behaviour in the wrapped class, this forwards all unknown instance variables, properties,
   * and methods on to the wrapped field.  This allows for generic modification of types that aren't known in
   * advance by the reduxdataloader.
   */


  _createClass(SchemaModifier, [{
    key: '_masquerade',
    value: function _masquerade() {
      // Add in instance variables
      var knownVariables = (0, _immutable.Set)(Object.getOwnPropertyNames(this));
      var unknownVariables = Object.getOwnPropertyNames(this.field).filter(function (k) {
        return !knownVariables.has(k);
      });
      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = unknownVariables[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var method = _step14.value;

          var descriptor = Object.getOwnPropertyDescriptor(this.field, method);
          Object.defineProperty(this, method, descriptor);
        }

        // Add in properties and methods
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }

      var knownMethods = (0, _immutable.Set)(Object.getOwnPropertyNames(this.constructor.prototype));
      var unknownMethods = Object.getOwnPropertyNames(this.field.constructor.prototype).filter(function (k) {
        return !knownMethods.has(k);
      });
      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = unknownMethods[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var _method = _step15.value;

          var _descriptor = Object.getOwnPropertyDescriptor(this.field.constructor.prototype, _method);
          Object.defineProperty(this, _method, _descriptor);
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }
    }
  }, {
    key: 'duplicate',
    value: function duplicate() {
      return new this.constructor(this.field);
    }
  }, {
    key: 'validateModifier',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateModifier(value, options) {
      return regeneratorRuntime.wrap(function validateModifier$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              throw new Error("Override validateModifier");

            case 1:
            case 'end':
              return _context15.stop();
          }
        }
      }, validateModifier, this);
    })
  }, {
    key: 'modifiers',
    get: function get() {
      var ret = [this.modifierType];
      return ret.concat(this.field.modifiers);
    }
  }, {
    key: 'modifierType',
    get: function get() {
      throw new Error("Override modifierType");
    }
  }]);

  return SchemaModifier;
}(SchemaField);

/*
 * MAYBE
 */


var MaybeModifier = function (_SchemaModifier) {
  _inherits(MaybeModifier, _SchemaModifier);

  function MaybeModifier() {
    _classCallCheck(this, MaybeModifier);

    return _possibleConstructorReturn(this, (MaybeModifier.__proto__ || Object.getPrototypeOf(MaybeModifier)).apply(this, arguments));
  }

  _createClass(MaybeModifier, [{
    key: 'findWalk',
    value: function findWalk(keyPath, options) {
      return this.field.findWalk(keyPath, options);
    }
  }, {
    key: 'getWalk',
    value: function getWalk(data, keyPath, options) {
      if (data === undefined || data === null) {
        // EARLY EXIT: Passthrough for null and undefined
        return this._getUndefinedPair;
      }
      return this.field.getWalk(data, keyPath, options);
    }
  }, {
    key: 'toImmutableWalk',
    value: function toImmutableWalk(data, options) {
      if (data === undefined || data === null) {
        // EARLY EXIT: Passthrough for null and undefined
        return data;
      }
      return this.field.toImmutableWalk(data, options);
    }
  }, {
    key: 'validateModifier',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateModifier(value, options) {
      return regeneratorRuntime.wrap(function validateModifier$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              if (!(value != undefined && value != null)) {
                _context16.next = 2;
                break;
              }

              return _context16.delegateYield(this.field.validateModifier(value, options), 't0', 2);

            case 2:
            case 'end':
              return _context16.stop();
          }
        }
      }, validateModifier, this);
    })
  }, {
    key: 'modifierType',
    get: function get() {
      return 'Maybe';
    }
  }]);

  return MaybeModifier;
}(SchemaModifier);

function getMaybe() {
  for (var _len7 = arguments.length, args = Array(_len7), _key8 = 0; _key8 < _len7; _key8++) {
    args[_key8] = arguments[_key8];
  }

  return new (Function.prototype.bind.apply(MaybeModifier, [null].concat(args)))();
}

/*********************************************************************************************************************
 * SPECIFIERS
 *********************************************************************************************************************/

var SchemaSpecifier = function () {
  function SchemaSpecifier() {
    _classCallCheck(this, SchemaSpecifier);
  }

  _createClass(SchemaSpecifier, [{
    key: 'validateSpecifier',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateSpecifier(field, value, options) {
      return regeneratorRuntime.wrap(function validateSpecifier$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
            case 'end':
              return _context17.stop();
          }
        }
      }, validateSpecifier, this);
    })
  }, {
    key: 'type',
    get: function get() {
      throw new Error("Override with type");
    }
  }]);

  return SchemaSpecifier;
}();

function specify(field, specifier) {
  if (!(field instanceof SchemaField)) {
    throw new Error(field + ' is not a SchemaField');
  }
  if (!(specifier instanceof SchemaSpecifier)) {
    throw new Error(specifier + ' is not a SchemaSpecifier');
  }
  return field.specify(specifier);
}

var RangedSpecifier = function (_SchemaSpecifier) {
  _inherits(RangedSpecifier, _SchemaSpecifier);

  function RangedSpecifier() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RangedSpecifier);

    var _this48 = _possibleConstructorReturn(this, (RangedSpecifier.__proto__ || Object.getPrototypeOf(RangedSpecifier)).call(this));

    var _options$min = options.min,
        min = _options$min === undefined ? undefined : _options$min,
        _options$max = options.max,
        max = _options$max === undefined ? undefined : _options$max;


    _this48.min = min;
    _this48.max = max;
    return _this48;
  }

  _createClass(RangedSpecifier, [{
    key: 'validateSpecifier',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateSpecifier(field, value, options) {
      return regeneratorRuntime.wrap(function validateSpecifier$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (!(this.min !== undefined && value < this.min)) {
                _context18.next = 5;
                break;
              }

              _context18.next = 3;
              return new SchemaRangeInvalidBelowMin(field, value, this.min, this.max);

            case 3:
              _context18.next = 8;
              break;

            case 5:
              if (!(this.max !== undefined && value > this.max)) {
                _context18.next = 8;
                break;
              }

              _context18.next = 8;
              return new SchemaRangeInvalidAboveMax(field, value, this.min, this.max);

            case 8:
            case 'end':
              return _context18.stop();
          }
        }
      }, validateSpecifier, this);
    })
  }, {
    key: 'type',
    get: function get() {
      return "Ranged";
    }
  }]);

  return RangedSpecifier;
}(SchemaSpecifier);

function getRanged(field) {
  for (var _len8 = arguments.length, args = Array(_len8 > 1 ? _len8 - 1 : 0), _key9 = 1; _key9 < _len8; _key9++) {
    args[_key9 - 1] = arguments[_key9];
  }

  return specify(field, new (Function.prototype.bind.apply(RangedSpecifier, [null].concat(args)))());
}

var SizedSpecifier = function (_SchemaSpecifier2) {
  _inherits(SizedSpecifier, _SchemaSpecifier2);

  function SizedSpecifier() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SizedSpecifier);

    var _this49 = _possibleConstructorReturn(this, (SizedSpecifier.__proto__ || Object.getPrototypeOf(SizedSpecifier)).call(this));

    var _options$min2 = options.min,
        min = _options$min2 === undefined ? undefined : _options$min2,
        _options$max2 = options.max,
        max = _options$max2 === undefined ? undefined : _options$max2;


    _this49.min = min;
    _this49.max = max;
    return _this49;
  }

  _createClass(SizedSpecifier, [{
    key: 'validateSpecifier',
    value: /*#__PURE__*/regeneratorRuntime.mark(function validateSpecifier(field, value, options) {
      var length;
      return regeneratorRuntime.wrap(function validateSpecifier$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              length = void 0;

              if (!(value !== undefined && value['size'] !== undefined)) {
                _context19.next = 5;
                break;
              }

              length = value.size;
              _context19.next = 12;
              break;

            case 5:
              if (!(value !== undefined && value['length'] !== undefined)) {
                _context19.next = 9;
                break;
              }

              length = value.length;
              _context19.next = 12;
              break;

            case 9:
              _context19.next = 11;
              return new SchemaSizeUnknown(field, value);

            case 11:
              return _context19.abrupt('return');

            case 12:
              if (!(this.min !== undefined && length < this.min)) {
                _context19.next = 17;
                break;
              }

              _context19.next = 15;
              return new SchemaSizeInvalidBelowMin(field, value, this.min, this.max);

            case 15:
              _context19.next = 20;
              break;

            case 17:
              if (!(this.max !== undefined && length > this.max)) {
                _context19.next = 20;
                break;
              }

              _context19.next = 20;
              return new SchemaSizeInvalidAboveMax(field, value, this.min, this.max);

            case 20:
            case 'end':
              return _context19.stop();
          }
        }
      }, validateSpecifier, this);
    })
  }, {
    key: 'type',
    get: function get() {
      return "Sized";
    }
  }]);

  return SizedSpecifier;
}(SchemaSpecifier);

function getSized(field) {
  for (var _len9 = arguments.length, args = Array(_len9 > 1 ? _len9 - 1 : 0), _key10 = 1; _key10 < _len9; _key10++) {
    args[_key10 - 1] = arguments[_key10];
  }

  return specify(field, new (Function.prototype.bind.apply(SizedSpecifier, [null].concat(args)))());
}

exports.MAP_KEY = MAP_KEY;
exports.MAP_VALUE = MAP_VALUE;
exports.FieldPrimitive = SchemaFieldPrimitive;
exports.Field = SchemaField;
exports.Modifier = SchemaModifier;
exports.Specifier = SchemaSpecifier;
exports.ValidationError = SchemaValidationError;
exports.BooleanInvalid = SchemaBooleanInvalid;
exports.DateInvalid = SchemaDateInvalid;
exports.IntegerInvalid = SchemaIntegerInvalid;
exports.IntegerBelowMin = SchemaIntegerBelowMin;
exports.IntegerAboveMax = SchemaIntegerAboveMax;
exports.KeysUnknown = SchemaKeysUnknown;
exports.ReferencePending = SchemaReferencePending;
exports.ListInvalid = SchemaListInvalid;
exports.MapInvalid = SchemaMapInvalid;
exports.NumberInvalid = SchemaNumberInvalid;
exports.NumberBelowMin = SchemaNumberBelowMin;
exports.NumberAboveMax = SchemaNumberAboveMax;
exports.RangeInvalid = SchemaRangeInvalid;
exports.RangeInvalidAboveMax = SchemaRangeInvalidAboveMax;
exports.RangeInvalidBelowMin = SchemaRangeInvalidBelowMin;
exports.SizeUnknown = SchemaSizeUnknown;
exports.SizeInvalid = SchemaSizeInvalid;
exports.SizeInvalidAboveMax = SchemaSizeInvalidAboveMax;
exports.SizeInvalidBelowMin = SchemaSizeInvalidBelowMin;
exports.SchemaInvalid = SchemaSchemaInvalid;
exports.StringInvalid = SchemaStringInvalid;
exports.StringBelowMinLength = SchemaStringBelowMinLength;
exports.StringAboveMaxLength = SchemaStringAboveMaxLength;
exports.Number = getNumberField;
exports.Integer = getIntegerField;
exports.Boolean = getBooleanField;
exports.String = getStringField;
exports.Date = getDateField;
exports.Any = getAnyField;
exports.AnyImmutable = getAnyImmutableField;
exports.ContainerField = SchemaContainerField;
exports.List = getList;
exports.Map = getMap;
exports.Schema = getSchema;
exports.PendingContainerField = PendingSchemaContainerField;
exports.PendingSchema = getPendingSchema;
exports.DynamicContainerField = SchemaDynamicContainerField;
exports.DynamicNeighbourSchema = getDynamicNeighbourSchema;
exports.DynamicInlineSchema = getDynamicInlineSchema;
exports.Maybe = getMaybe;
exports.Ranged = getRanged;
exports.Sized = getSized;